import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { Icon } from '../../../components/common/icon/Icon';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { useGetDictionaryTagsQuery } from '../../../hooks/api/dictionary/queries/useGetDictionaryTags.query';
import { useLayout } from '../../../hooks/screen/useLayout';
import { DictionaryChooseTagSection } from '../components/DictionaryChooseTagSection';

export const DictionaryBrandListPage = () => {
  const navigate = useNavigate();

  useLayout({
    fixedHeader: (
      <>
        <MainHead backButton={{ isShow: true }} />
        <DictionaryChooseTagSection />
      </>
    ),
    fixedHeaderHeight: 100,
    fixedFooterHeight: 92,
  });

  const { data: dictionaryBrandTags, isLoading: isGetDictionaryBrandTagsQueryLoading } = useGetDictionaryTagsQuery({
    // TODO : categoryId 값을 UUID로 변경 또는 categoryName 기반으로 검색하도록 기능 변경
    categoryId: 'BRAND',
  });

  if (isGetDictionaryBrandTagsQueryLoading) return <AnimateLoading />;

  if (dictionaryBrandTags) {
    return (
      <BrandList>
        {dictionaryBrandTags.map((brandTag) => (
          <BrandItem onClick={() => navigate(`/dictionary/machines?tagId=${brandTag.id}&from=brandList`)}>
            <BrandImage src={brandTag.image} />
            <BrandInfoContainer>
              <BrandName>{brandTag.title}</BrandName>
              <GoToBrandPage>
                <Icon name={'ArrowRight'} width={12} height={12} />
              </GoToBrandPage>
            </BrandInfoContainer>
            <HR />
          </BrandItem>
        ))}
      </BrandList>
    );
  }

  return <></>;
};

const BrandList = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  padding: 16px;

  gap: 16px;
`;

const BrandItem = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 16px;

  position: relative;

  cursor: pointer;
`;

const BrandImage = styled.img`
  width: 40px;
  height: 40px;

  border-radius: 16px;
`;

const BrandInfoContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BrandName = styled.h2`
  color: #232429;
  font-size: 14px;
  font-weight: 500;
  line-height: 100%; /* 14px */
`;

const GoToBrandPage = styled.button``;

const HR = styled.hr`
  width: 100%;

  position: absolute;

  max-width: 860px;

  bottom: -8px;
`;
